import type { Route } from '../admin-fetch';
import { callServer } from '../server';
import { badRequest, bodyOf, toResponse } from '../respond';

const BASE = '/api/v1/admin/currencies';

// Who may add or change a currency (not viewers) is decided by the server.
export const currencyRoutes: Route[] = [
  ['GET', '/api/currencies', async () => toResponse(await callServer('GET', BASE), 'currencies')],
  ['POST', '/api/currencies', async (req) =>
    toResponse(await callServer('POST', BASE, { body: await bodyOf(req) }), 'currency', 201)],
  ['PATCH', '/api/currencies', async (req) => {
    const { code, isActive } = await bodyOf(req);
    if (typeof code !== 'string' || typeof isActive !== 'boolean') {
      return badRequest('code and isActive are required');
    }
    return toResponse(
      await callServer('PATCH', `${BASE}/${encodeURIComponent(code)}`, { body: { isActive } }),
      'currency',
    );
  }],
];
